import React from 'react';

import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';

import homePageV2Messages from './assets/messages/homePageMessages';
import { EcoFriendlyIcon, SendIcon } from '../primitive/icons/pdpIcons';
import { getFormattedMessage } from '../utils/textUtils';



export const printAtHomeHighlightBulletLists = (intl) => {
    

    const bulletText = [
        {
            icon: <EcoFriendlyIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.printAtHomeDescriptionBullet1)
        },
        {
            icon: <SendIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.printAtHomeDescriptionBullet2)
        },
        {
            icon: <WorkspacePremiumOutlinedIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.printAtHomeDescriptionBullet3)
        }
    ];

    
    const sortedPrintAtHomeHighlightBulletList = bulletText.filter(item => item.text.trim() !== '');

    return sortedPrintAtHomeHighlightBulletList;
};
